// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"addShipFormStyle_errorMessage__2hAmz","responseErrorMessage":"addShipFormStyle_responseErrorMessage__fHtbU"};